import useAxiosInterceptor from '../interceptor';
import { apiPath } from './constants';

class PatientService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getPatientRecord = (payload: any) => {
    return this.axiosInstance.post(apiPath.patients, payload?.data, {
      params: payload?.params,
    });
  };

  getTherapistDisciplinePatient = (payload: any) => {
    return this.axiosInstance.get(`/provider/therapist-to-assign/${payload?.discipline}`);
  };
  getTreatmentTherapist = (payload: any) => {
    return this.axiosInstance.put(
      `/provider/${payload?.payload?.therapistId}/scheduling/${payload?.payload?.taskId}/treat-therapist`
    );
  };

  getPatientActiveInActiveCounts = (payload: any) => {
    return this.axiosInstance.get(`${apiPath.PATIENT}/count/${payload.facilityId}`);
  };

  getDownloadPatientCSVTemplate = () => {
    return this.axiosInstance.get(`${apiPath.PATIENT_CSV_TEMPLATE}/download-template`);
  };

  validateCSVTemplate = (payload: any) => {
    return this.axiosInstance.post(`${apiPath.PATIENT_CSV_TEMPLATE}/validate`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  uploadCSVTemplate = (payload: any) => {
    return this.axiosInstance.post(`${apiPath.PATIENT_CSV_TEMPLATE}/upload`, payload);
  };

  getPatientHistory = () => {
    return this.axiosInstance.get(apiPath.PATIENT_HISTORY);
  };

  getPatientExportTemplate = (payload: any) => {
    return this.axiosInstance.post(apiPath.PATIENT_EXPORT_CSV, payload);
  };

  getAllPatientWithoutPagination = () => {
    return this.axiosInstance.get(`${apiPath.GET_ALL_PATIENT}`);
  };
}

const patientService = new PatientService();

Object.freeze(patientService);

export default patientService;
